import { Accommodation } from '@silbo/core';
import { createFileRoute } from '@tanstack/react-router';
import ArchivedRequestDetailsPage from '../../../features/bed-management/pages/ArchivedRequestDetailsPage';
import { getAccommodationFromRequestQueryOptions } from '../../../features/bed-management/queries/get-accommodation-from-request';
import { getRequestQueryOptions } from '../../../features/bed-management/queries/get-request/get-request-query-options';

export const Route = createFileRoute('/_auth/bed-management/archives/$id')({
  loader: async ({ context, params }) => {
    const performerRequest = await context.queryClient.ensureQueryData(getRequestQueryOptions(params.id));

    let accommodation: Accommodation | undefined = undefined;
    if (performerRequest?.request?.status === 'ACCEPTED') {
      accommodation = await context.queryClient.ensureQueryData(
        getAccommodationFromRequestQueryOptions(performerRequest.request)
      );
    }

    return {
      request: performerRequest,
      accommodation,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  return <ArchivedRequestDetailsPage requestId={id} />;
}
